import { graphql, useStaticQuery } from "gatsby";
import { find, get } from 'lodash';
import React from 'react';

import { ActivedemandForm } from '../activedemand-form';
import {
	Body,
	Description,
	Header,
	StyledContainer, StyledContent,
	Title
} from './contact-form.styles';


const ContactForm = () => {

	const data = useStaticQuery(graphql`
		query ContactFormQuery {
			forms:allActiveDemandForm {
				nodes {
					id
					formId
					formHTML
					fields{
						type
						label
						list
						required
						choices
						dynamic
						key
						value
					}
				}
			}
			footer:datoCmsFooter {
				formTitle
				formDescription
				form {
					formId
					heading
					note
					success
					error
				}
			}
		}
	`)

	const footer = get(data, "footer");
	const forms = get(data, "forms").nodes;

	if (!forms || !footer) return null;

	const activeDemandForm = find(forms, { formId: footer.form.formId });

	return (
		<StyledContainer id="contact-form">
			<StyledContent>
				<Header>
					<Title>{footer.formTitle}</Title>
					<Description dangerouslySetInnerHTML={{ __html: footer.formDescription }} />
				</Header>
				<Body>
					<ActivedemandForm {...activeDemandForm} {...footer.form} />
				</Body>
			</StyledContent>
		</StyledContainer>
	)
}

export default ContactForm;